import { Lock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';

const FONT_BODY = { fontFamily: "'Crimson Text', Georgia, serif" };

export const AdminCodeDialog = ({ open, onOpenChange, adminCode, setAdminCode, onSubmit, error }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md" data-testid="admin-code-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-2xl text-blue-800">
          <Lock className="h-5 w-5" /> Admin Access
        </DialogTitle>
        <DialogDescription style={FONT_BODY}>
          Enter the admin code to manage events.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label htmlFor="admin-code" style={FONT_BODY} className="text-blue-800 font-semibold">Admin Code</Label>
          <Input
            id="admin-code"
            data-testid="admin-code-input"
            type="password"
            value={adminCode}
            onChange={(e) => setAdminCode(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
            placeholder="Enter admin code"
            className="mt-1 border-2 border-blue-200 focus:border-blue-500"
            style={FONT_BODY}
          />
          {error && (
            <p data-testid="admin-error" className="text-red-500 text-sm mt-2" style={FONT_BODY}>{error}</p>
          )}
        </div>
      </div>
      <DialogFooter>
        <Button data-testid="admin-submit-btn" onClick={onSubmit} className="bg-blue-700 hover:bg-blue-800 text-white font-semibold" style={FONT_BODY}>
          Verify
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
